/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Task } from '../../models/task';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeactivateTask$Params {
  taskId: string;
}

export function deactivateTask(
  http: HttpClient,
  rootUrl: string,
  params: DeactivateTask$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Task>> {
  const rb = new RequestBuilder(rootUrl, deactivateTask.PATH, 'post');
  if (params) {
    rb.path('taskId', params.taskId, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Task>;
    }),
  );
}

deactivateTask.PATH = '/manage/task/{taskId}/deactivate';
